// Currency configuration
// Currencies are now dynamic based on admin-created plans
// No conversion needed - we just display the currency from the plan

export const DEFAULT_CURRENCY = 'INR';
export const STORAGE_KEY = 'spacebyte_currency';
